import styled from 'styled-components';

import colors from '../../../../../../../styles/colors';

const ScrollableContainer = styled.div`
  max-height: 250px;
  overflow-y: auto;
  padding: 10px;
  scrollbar-width: none;
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 5px;
  background-color: ${colors.base.support};
`;

const MessageContainer = styled.div`
  display: flex;
  justify-content: ${({ $isUser }) => ($isUser ? 'flex-start' : 'flex-end')};
  margin-bottom: 10px;
`;

const Message = styled.div`
  max-width: 80%;
  background-color: ${({ $isUser }) => ($isUser ? colors.shades.secondary2 : colors.shades.gamma13)};
  color: ${({ $isUser }) => ($isUser ? 'white' : '#202124')};
  padding: 12px;
  border-radius: ${({ $isUser }) => ($isUser ? '18px 18px 18px 4px' : '18px 18px 4px 18px')};
  position: relative;
`;

const MessageContent = styled.div`
  font-size: 13px;
  white-space: pre-wrap;
`;

const Timestamp = styled.div`
  font-size: 11px;
  opacity: 0.7;
  margin-top: 4px;
  text-align: right;
`;

export {
  ScrollableContainer,
  MessageContainer,
  Message,
  MessageContent,
  Timestamp,
};
